@if(!hasError()){
    @if (!loaded()) {
    <div class="w-full h-[225px] animate-pulse">
        <div class="animate-pulse w-full h-full bg-dat-grey-300">
        </div>
    </div>
    }
    @else {
    <div [id]="id()" [attr.data-testid]="id()" [attr.data-styletarget]="id()" class="w-full h-[250px]">
        <div [id]="id() + '-graph'" [attr.data-testid]="id() + '-graph'" [attr.data-styletarget]="id() + '-graph'"
            class="w-full h-full" #graph>
        </div>
    </div>
    }
    }
    @else {
    <div class="w-full h-[225px]">
        <div class="w-full h-full">
            <div class="flex flex-col items-center justify-center h-full">
                <span class="material-symbols-outlined text-5xl text-dat-grey-600">
                    deployed_code_alert
                </span>
                <span class="text-dat-grey-800 font-caption text-[14px] mt-2">
                    {{errors().title}}
                </span>
                <span class="text-dat-grey-600 font-caption text-[12px] m-0">
                    {{errors().body}}
                </span>
            </div>
        </div>
    </div>
    }